module.exports = __webpack_public_path__ + "img/map_mobile_2.defd9ee7.png";